module.exports = __webpack_public_path__ + "static/media/x-mark.fb8719b8.svg";